import React, { useEffect, useState } from 'react';
// import styled from "styled-components";
import style from "../styles/GoToBtn.module.css"
import {BsFillArrowUpCircleFill} from "react-icons/bs"
const GoToTop = () => {
    const [isVisible, setIsVisible] = useState(false);
  
    const goToBtn = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };
  
    const listenToScroll = () => {
      let heightToHidden = 450;
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
  
      if (winScroll > heightToHidden) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
  
    useEffect(() => {
      window.addEventListener("scroll", listenToScroll);
      return () => window.removeEventListener("scroll", listenToScroll);
    }, []);
  
    return (
      <>
        {isVisible && (
          <div className={style.top_btn} onClick={goToBtn}>
            <BsFillArrowUpCircleFill className={style.top_btn_icon} />
          </div>
        )}
      </>
    )
  };
  export default GoToTop;